import Vue from 'vue'
import { normalize } from 'normalizr'
import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'
import { workerSchema } from '@/schema/worker'
import { WorkerEntities } from '@/schema/worker/types'
import { Worker } from '@/types/user'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  workers: {},
  sort: []
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  workers: state => state.workers,
  sort: state => (Array.isArray(state.sort) ? state.sort : []),
  workersAsArray: state =>
    Array.isArray(state.sort) ? state.sort.map(id => state.workers[id]) : []
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  add: (state, { workers, sort = undefined, toAppend = true }) => {
    if (sort === undefined) {
      sort = Object.keys(workers).map(id => Number(id))
    }

    sort = sort.filter(id => !state.workers[id])

    state.sort = toAppend
      ? (state.sort || []).concat(sort)
      : sort.concat(state.sort || [])

    state.workers = Object.assign({}, state.workers, workers)
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async add({ commit }, { patientIds, toAppend = true }) {
    const res = await Vue.$api.user.workerList({ patientIds })

    const { result, entities } = normalize<Worker[], WorkerEntities, number[]>(
      res.results,
      [workerSchema]
    )

    const { workers } = entities

    commit('add', {
      sort: result,
      workers,
      toAppend
    })
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
